import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import {OEHideFlags} from '../../../react-oe/oe-types';
import CustomScrollbar, {CustomScrollbarTrackVisibility} from '../../../lib/custom-scrollbar/custom-scrollbar';
import LocalStorage from '../../../lib/tools/local-storage';
import OECoreHideLayer from '../../views/oe-core-hide-layer';
import {OECustomCheckbox} from '../../elements/controls/oe-checkbox';
import OEStdModalController from '../../modals/oe-std-modal-controller';
import {OEWelcomeViewProps, OEWelcomeViewConfigFactory} from '../../views/welcome-view/oe-welcome-view-model';

export class OECambridgeCellWelcomeView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            dontShowAtStartUp:      LocalStorage.getItem('dontShowWelcomeViewAtStartUp') === 'true',
            strings: {
                paragraph1:         '',
                paragraph2:         '',
                paragraph3:         '',
                dontShowAgain:      '',
            },
            willOpenAtStartUp:      false,
            atStartUp:              false
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onRef = this.onRef.bind(this);

        this.onOpenStateChanged = this.onOpenStateChanged.bind(this);

        this.onDontShowAgainClicked = this.onDontShowAgainClicked.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(this.timeout && this.shouldOpenAtStartUp() != this.shouldOpenAtStartUp(nextProps))   {
            this.setState({willOpenAtStartUp: this.shouldOpenAtStartUp(nextProps)});
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        
        this.setState({willOpenAtStartUp: this.shouldOpenAtStartUp()});
        this.timeout = setTimeout(this.onTimeout.bind(this), 500);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);

        if(this.timeout)    {
            clearTimeout(this.timeout);
            this.timeout = 0;
        }
    }

    shouldOpenAtStartUp(props)   {
        props = props || this.props;
        return props.config.showAtStartUp &&
                (!props.config.welcomeViewShowedAtStartFlag || !props.appState.welcomeViewShowedAtStart) &&
                (LocalStorage.getItem('dontShowWelcomeViewAtStartUp') !== 'true');
    }

    onTimeout() {
        if(this.oe.isReady() && this.shouldOpenAtStartUp())   {
            if(this.ref)    this.ref.setOpen(true);
            if(this.props.config.welcomeViewShowedAtStartFlag && this.props.setAppState)   this.props.setAppState({welcomeViewShowedAtStart: true});
            this.setState({atStartUp: true});
        }
        this.setState({willOpenAtStartUp: false});
        this.timeout = 0;
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;
        this.setState({strings: {
            paragraph1:         si.getLocalizedStringEnc('welcome_view_cambridge_paragraph_1'),
            paragraph2:         si.getLocalizedStringEnc('welcome_view_cambridge_paragraph_2'),
            paragraph3:         si.getLocalizedStringEnc('welcome_view_cambridge_paragraph_3'),
            dontShowAgain:      si.getLocalizedStringEnc('welcome_view_cambridge_dont_show_again')
        }});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }
        this.updateLanguage();
    }

    onRef(ref)  {
        this.ref = ref;
        if(this.props.fref) this.props.fref(ref);
    }

    renderDontShowAgainCheckbox()   {
        //if(!this.props.config.showAtStartUp)    return null;

        return (
            <div>
                <OECustomCheckbox className="show-again-cb std-label-border-color" checked={this.state.dontShowAtStartUp} onPressed={this.onDontShowAgainClicked}/>
                <span>{this.state.strings.dontShowAgain}</span>
            </div>
        );
    }

    render() {
        let coreHideFlags = this.state.willOpenAtStartUp || this.state.atStartUp ? OEHideFlags.scene : 0;

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEStdModalController 
                    moduleId={this.props.moduleId}
                    headerStringId="welcome_view"
                    className="welcome-view cambridge"
                    isOpen={this.props.isOpen}
                    onToggle={this.props.onToggle}
                    onOpenStateChanged={this.onOpenStateChanged}
                    logo={this.props.config.logo}
                    renderFooter={() => <div className="bg-footer"/>}
                    coreHideFlags={coreHideFlags}
                    blurBackground={true}
                    ref={this.onRef}
                >
                    <CustomScrollbar
                        horizontalTrackVisiblity={CustomScrollbarTrackVisibility.none}
                        verticalTrackVisiblity={CustomScrollbarTrackVisibility.always}
                    >
                        <div className="paragraph-1">
                            {this.state.strings.paragraph1}
                        </div>

                        <div className="paragraph-2">
                            {this.state.strings.paragraph2}
                        </div>

                        <div className="paragraph-3">
                            <a className="std-label-text-color" href="https://www.gurdon.cam.ac.uk" target="_blank">{this.state.strings.paragraph3}</a>
                        </div>

                        <div className="paragraph-4">
                            {this.renderDontShowAgainCheckbox()}
                        </div>
                    </CustomScrollbar>
                </OEStdModalController>

                <OECoreHideLayer moduleId={this.props.moduleId} hideFlags={this.state.willOpenAtStartUp ? coreHideFlags : 0}/>

            </React.Fragment>
        );
    }

    onOpenStateChanged(sender, isOpen)    {

        if(isOpen && this.props.config.welcomeViewShowedAtStartFlag && this.props.appState && !this.props.appState.welcomeViewShowedAtStart && this.props.setAppState)    this.props.setAppState({welcomeViewShowedAtStart: true});

        //
        if(!isOpen && this.state.atStartUp && LocalStorage.getItem('dontShowStartViewAtStartUp') !== 'true' && this.props.appComponent && this.props.appComponent.uiLayer && this.props.appComponent.uiLayer.startView)   {
            this.props.appComponent.uiLayer.startView.setOpen(true);
        }

        //
        if(!isOpen) this.setState({atStartUp: false});

        //
        if(this.props.onOpenStateChanged)  this.props.onOpenStateChanged(sender, isOpen);
    }

    onDontShowAgainClicked()    {
        let newState = !this.state.dontShowAtStartUp;
        LocalStorage.setItem('dontShowWelcomeViewAtStartUp', newState ? 'true' : 'false');
        this.setState({dontShowAtStartUp: newState});
    }
}

OECambridgeCellWelcomeView.defaultProps = {
    moduleId:                   '',
    config:                     OEWelcomeViewConfigFactory.buildStdConfig()
};

OECambridgeCellWelcomeView.propTypes = {
    moduleId:                   PropTypes.string,
    isOpen:                     PropTypes.bool,
    onOpenStateChanged:         PropTypes.func,
    onToggle:                   PropTypes.func,
    config:                     OEWelcomeViewProps.config
};

//
export default frefFromRef(connectAppEnv((env) => {
    return {
        appState:               env.state,
        setAppState:            env.setState
    };
})(OECambridgeCellWelcomeView));